import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetSwitchedOffCatalogsQuery = (warehouseUids?: string[]) => {
  return useQuery({
    queryKey: ['getSwitchedOffCatalogs', warehouseUids],
    queryFn: () => Api.products.getCatalogs({ warehouse_uid: warehouseUids }),
    enabled: !!warehouseUids?.length,
    cacheTime: 0,
  });
};
